import { render } from "./errpage.vue?vue&type=template&id=40c6a654"
import script from "./errpage.vue?vue&type=script&lang=js"
export * from "./errpage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\work\\project\\intelegent\\ips\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__